/**
 * Matchers for "custom" (API-defined) attributes
 * @module
 */

module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./provider'));

  var matcher = require('./matchers/custom_attribute');

  PluginManager.registerAudienceMatcher('custom_attribute', matcher);

  // NB. Alias to custom_dimension for backwards compatibility
  PluginManager.registerAudienceMatcher('custom_dimension', matcher);
};
